import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { Box, TextField } from "@mui/material";
import type { ChangeEvent } from "react";
import { fetchValidations } from "../../../utils/helperFns";
import ErrorMessageHandle from "../Error/ErrorMessageHandle";

const HEX_COLOR_PATTERN = /^#([0-9A-Fa-f]{6})$/;

const ColorPicker = ({
  field,
  error,
  register,
  clearErrors,
  handleChange,
  handleOnBlur,
  data,
  isDisabled = false,
}: any) => {
  const validations = fetchValidations(field?.validations);
  const swatchValue = HEX_COLOR_PATTERN.test(data) ? data : "#000000";

  const {
    onChange: registeredOnChange,
    onBlur: registeredOnBlur,
    ...fieldRegistration
  } = register(field?.name, {
    ...validations,
    onChange: (event) => {
      if (error) {
        clearErrors(field?.name);
      }
      handleChange(event);
    },
    onBlur: (event) => handleOnBlur(event),
  });

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "stretch", gap: 1 }}>
        <Box
          sx={{
            position: "relative",
            width: 40,
            flexShrink: 0,
            borderRadius: "5px",
            overflow: "hidden",
          }}>
          <Box
            component='input'
            type='color'
            aria-label={field?.title ? `${field.title} color swatch` : "Color swatch"}
            value={swatchValue}
            disabled={isDisabled}
            onChange={(event: ChangeEvent<HTMLInputElement>) =>
              registeredOnChange({ target: { name: field?.name, value: event.target.value } })
            }
            sx={{
              width: "100%",
              height: "100%",
              minHeight: 40,
              border: "1px solid #d9d9d9",
              borderRadius: "5px",
              cursor: isDisabled ? "not-allowed" : "pointer",
              opacity: isDisabled ? 0.6 : 1,
              padding: 0,
              "&::-webkit-color-swatch-wrapper": { padding: 0 },
              "&::-webkit-color-swatch": { borderRadius: "4px", border: "none" },
            }}
          />
          <EditOutlinedIcon
            aria-hidden
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              fontSize: 16,
              color: "#fff",
              pointerEvents: "none",
              filter: "drop-shadow(0 0 1px rgba(0,0,0,0.7))",
            }}
          />
        </Box>
        <Box sx={{ flex: 1 }}>
          <TextField
            variant='filled'
            size='small'
            fullWidth
            name={field?.name}
            id={field?.name}
            placeholder='#000000'
            error={error}
            disabled={isDisabled}
            value={data}
            {...fieldRegistration}
            onChange={registeredOnChange}
            onBlur={registeredOnBlur}
          />
        </Box>
      </Box>
      <ErrorMessageHandle error={error} />
    </Box>
  );
};

export default ColorPicker;
